import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  toggle({ detail: { content } }) {
    const isExpanding = content;

    if (isExpanding) {
      // Any explicit max-height that will always be larger than the content
      this.contentTarget.classList.add("max-h-1000");
      this.contentTarget.classList.remove("max-h-0");
    } else {
      this.contentTarget.classList.remove("max-h-1000");
      this.contentTarget.classList.add("max-h-0");
    }
  }
}
